import React from 'react';
import { Layout } from './Layout';

interface TripsLayoutProps {
  children: React.ReactNode;
  sidePanel?: React.ReactNode;
  title?: string;
  subtitle?: string;
}

export const TripsLayout: React.FC<TripsLayoutProps> = ({
  children,
  sidePanel,
  title,
  subtitle,
}) => {
  return (
    <Layout>
      <div className="flex h-full">
        {/* Left pane - Travel portal sidebar */}
        {sidePanel && (
          <div className="w-80 bg-white border-r border-gray-100 flex-shrink-0">
            {sidePanel}
          </div>
        )}

        {/* Right pane - Detail view */}
        <div className="flex-1 overflow-auto">
          <div className="p-6">
            {title && (
              <div className="mb-6">
                <h1 className="text-2xl font-bold text-gray-900">{title}</h1>
                {subtitle && (
                  <p className="mt-2 text-sm text-gray-600">{subtitle}</p>
                )}
              </div>
            )}
            {children}
          </div>
        </div>
      </div>
    </Layout>
  );
};
